import Customer from './Customer'
import CustomerDetails from './details/CustomerDetails'

export const ROUTES = [
  {
    component: Customer,
    isPublic: true,
    path: '/customers',
    slug: 'customers',
    title: 'customers',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: CustomerDetails,
    isPublic: true,
    path: '/customers/:id',
    isExact: true,
    slug: 'customers',
    title: 'customers',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
  },
]
